import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import axios from 'axios';
import './scss/style.scss';
import { ProtectedRoute } from 'src/reusable'
import { CSpinner } from '@coreui/react'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/student/TheLayout'));
const TheMasterLayout = React.lazy(() => import('./containers/master/TheMasterLayout'));
const TheInstructorLayout = React.lazy(() => import('./containers/instructor/TheInstructorLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));


class App extends Component {

  componentWillMount(){
    axios.interceptors.request.use(function (config) {

      let spinner = document.getElementsByClassName("whole-page-spinner")
      if (spinner.length > 0)
        spinner[0].style.display = "block";

      const token = window.localStorage.token;
      if (token) {
         config.headers.Authorization = `token ${token}`
      }
      return config
    }, function (error) {
      return Promise.reject(error);
    });

    axios.interceptors.response.use(function (response) {
      let spinner = document.getElementsByClassName("whole-page-spinner")
      if (spinner.length > 0)
        spinner[0].style.display = "none";
      return response;
    }, function (error) {
      let spinner = document.getElementsByClassName("whole-page-spinner")
      if (spinner.length > 0)
        spinner[0].style.display = "none";
      return Promise.reject(error);
    });
  }

  render() {
    return (
      <>
        <CSpinner className="whole-page-spinner"/>
        <HashRouter>
            <React.Suspense fallback={loading}>
              <Switch>
                <Route exact path="/login" name="登录页" render={props => <Login {...props}/>} />
                <Route exact path="/register" name="注册页" render={props => <Register {...props}/>} />
                <Route exact path="/404" name="404页" render={props => <Page404 {...props}/>} />
                <Route exact path="/500" name="500页" render={props => <Page500 {...props}/>} />
                <ProtectedRoute path="/master" name="导师首页" render={props => <TheMasterLayout {...props}/>} />
                <ProtectedRoute path="/instructor" name="助教首页" render={props => <TheInstructorLayout {...props}/>} />
                <ProtectedRoute path="/" name="首页" render={props => <TheLayout {...props}/>} />
              </Switch>
            </React.Suspense>
        </HashRouter>
      </>
    );
  }
}

export default App;
